import React from 'react';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router';
// import NavigationConfig from '../../../../navigation/config';
import * as AuthSelectors from '../../../../redux/reducers/gl_auth_reducer/selectors';
import ModalActions from 'redux/reducers/gl_modal_reducer/actions';
import { ModalIDs } from 'redux/reducers/gl_modal_reducer/types';
import { useDispatch } from 'react-redux';

interface IProps {
  payment_info_id: number;
  payment_reference: string;
  payment_date: Date;
  status: number;
}

export default function ActionsBlock(props: IProps) {
  // const history = useHistory();
  // const ROLE = AuthSelectors.useSelectUserRole();
  const dispatch = useDispatch();

  const editPaymentInfo = () => {
    dispatch(
      ModalActions.openModalAction({
        modalID: ModalIDs.MODAL_UPDATE_PAYMENT_INFO_REFERENCE,
        params: {
          payment_info_id: props.payment_info_id,
          payment_reference: props.payment_reference,
          payment_date: props.payment_date,
        },
      })
    );
  };

  return (
    <div>
      <Button disabled={props.status === 1} onClick={() => editPaymentInfo()}>
        GENERATE XML
      </Button>
      {/* <Button></Button> */}
    </div>
  );
}
